import { DatePipe } from "@angular/common";
import { StatusEnum } from "../enums/status.enum";
import { JobModel } from "../models/job.model";
import { Task } from "./task.class";
import { TaskModel } from "../models/task.model";
import { TaskEnum } from "../enums/task.enum";
import { Language } from "../models/language.model";


export class Job {
    private datePipe = new DatePipe('fr-FR');

    constructor(private job: JobModel) { }

    get data(): JobModel {
        return this.job;
    }

    get id() {
        return this.job.id;
    }

    get title() {
        return this.job.title;
    }

    get duration(): number | null {
        return this.job.duration;
    }

    get createdAt() {
        return this.formatDate(this.job.created_at);
    }

    get updatedAt(): string | null {
        return this.job.updated_at ? this.formatDate(this.job.updated_at) : null;
    }

    get context(): string | null {
        return this.job.context;
    }

    get fileExtention(): string {
        return this.job.file_extension;
    }

    get thumbnail(): string {
        return this.job.thumbnailUrl;
    }

    get tasks(): Task[] {
        let allTasks: TaskModel[] = [];
        const tasksTypes: string[] = Object.keys(TaskEnum).filter((value: string) => Number.isNaN(parseInt(value)));
        tasksTypes.forEach((taskType: string, index: number) => {
            const findedTasks: TaskModel[] = this.job.tasks.filter((task: TaskModel) => TaskEnum[task.type] === taskType)
            if (findedTasks.length > 0) {
                allTasks = [...allTasks, ...findedTasks];
            } else {
                allTasks = [...allTasks, {
                    id: null,
                    status: StatusEnum.PENDING,
                    job: null,
                    type: index,
                    message: null,
                    progress: null,
                    updated_at: null,
                    created_at: null,
                    deleted_at: null
                }];
            }
        })
        return allTasks.map((task: TaskModel) => new Task(task));
    }

    get LangFrom(): Language {
        return this.job.lang_source
    }

    get LangTo(): Language {
        return this.job.lang_cible
    }

    get currentTask(): Task {
        return new Task(this.job.tasks[this.job.tasks.length - 1])
    }

    get status(): string {
        return Object.keys(StatusEnum).find(key => StatusEnum[key as keyof typeof StatusEnum] === this.job.status) || 'UNKNOWN';
    }

    get active(): boolean {
        return this.job.deleted_at === null && this.job.status !== StatusEnum.COMPLETED;
    }

    get completed(): boolean {
        return this.job.status === StatusEnum.COMPLETED;
    }

    get completedPercent(): number {
        let totalCompleted: number = 0;
        this.tasks.forEach((task: Task) => {
            switch (task.status) {
                case ('IN_PROGRESS'):
                case ('ERROR'):
                    totalCompleted += task.progress ?? 0;
                    break;
                case ('COMPLETED'):
                    totalCompleted += 100;
                    break;
                default:
                    totalCompleted += 0
            }
        })

        return Math.round(totalCompleted / this.tasks.length);
    }

    private formatDate(date: Date): string {
        if (!(date instanceof Date)) {
            date = new Date(date);
        }
        const today = new Date();
        const diff = Math.abs(today.getDay() - date.getDay());
        if (diff === 0) {
            return 'Aujourd\'hui à ' + this.datePipe.transform(date, 'HH:mm:ss') || 'date not available';
        } else if (diff === 1) {
            return 'Hier à ' + this.datePipe.transform(date, 'HH:mm:ss') || 'date not available';

        } else if (diff === 2) {
            return 'Avant hier à ' + this.datePipe.transform(date, 'HH:mm:ss') || 'date not available';
        } else {
            return this.datePipe.transform(date, 'dd/MM/yyyy') || 'date not available';
        }
    }
}